import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import LocalizedLink from './router/LocalizedLink'
import store from './store'
import i18n from './i18n'
import reveal, { refreshReveal } from './animations/reveal'
import count from './animations/count'
import { initAccessibility } from './accessibility/state'
import { formatDate } from './utils/date'
import './styles/app.scss'

// ⚠️ DO NOT REMOVE — scroll-to-top-on-refresh (2 of 3).
// Disables the browser's native scroll restoration so a refresh always opens at
// the top instead of where the user last was. Works together with the
// `isFreshLoad` branch in router/index.js and the window.scrollTo fallback in
// App.vue. Drop this and refreshing a scrolled page jumps back down — leave it.
if ('scrollRestoration' in history) history.scrollRestoration = 'manual'

const app = createApp(App)

// Global scroll-reveal directive: v-reveal (+ .stagger / .left / .right / .zoom)
app.directive('reveal', reveal)
// Global count-up directive: v-count (numbers tick from 0 on scroll-in)
app.directive('count', count)

// Recompute reveal trigger positions after each navigation, once the new
// page has painted (lazy routes + async data change the document height).
router.afterEach(() => {
  requestAnimationFrame(() => setTimeout(refreshReveal, 120))
})

app.use(store).use(router)

// `{{ $fdate(item.date) }}` — one date format everywhere, in the active language
// (see utils/date.js). Reads the i18n locale ref, so it re-renders on switch.
app.config.globalProperties.$fdate = formatDate

// Registered AFTER app.use(router), so it shadows vue-router's own RouterLink:
// every `to="/…"` in the templates picks up the active language prefix without
// each link having to spell it out. See router/LocalizedLink.js. Vue logs one
// "already registered" notice for this in dev — the override is the point.
app.component('RouterLink', LocalizedLink)

app.use(i18n).mount('#app')

// Re-apply saved accessibility settings (vision mode, zoom, reader) on load.
initAccessibility()
